export default __webpack_public_path__ + "static/media/Banner.190d2a8e.jpeg";